// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__deb1Z","messages":"Chat_messages__1E7y9","dateDivider":"Chat_dateDivider__1TrgP"};